const _excluded = ["children"];
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.includes.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { NotificationHubContext, useNotificationHubContext } from "./notification-hub.context";
import { createEmptyNotificationHub } from "./notification-hub.vm";
import { NotificationHub } from "../../base";
const NotificationHubItems = props => {
  const {
    notifications,
    setNotifications
  } = useNotificationHubContext();
  return /*#__PURE__*/React.createElement(NotificationHub, _extends({
    items: notifications,
    onChange: setNotifications
  }, props));
};

/**
 * Cambiar por -> NotificationToastifyProvider
 * @deprecated
 */
export const NotificationHubProvider = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [notifications, setNotifications] = React.useState(createEmptyNotificationHub());
  const addNotifications = React.useCallback(notifications => {
    setNotifications(items => [...items, ...notifications]);
  }, []);
  const removeNotificationsByKey = notificationKeys => {
    setNotifications(items => [...items].filter(x => !notificationKeys.includes(x.key)));
  };
  return /*#__PURE__*/React.createElement(NotificationHubContext.Provider, {
    value: {
      notifications,
      setNotifications,
      addNotifications,
      removeNotifications: removeNotificationsByKey
    }
  }, children, /*#__PURE__*/React.createElement(NotificationHubItems, rest));
};